import { render, staticRenderFns } from "./RsaStoricoPostoLettoViewPage.vue?vue&type=template&id=79bc917b"
import script from "./RsaStoricoPostoLettoViewPage.vue?vue&type=script&lang=js"
export * from "./RsaStoricoPostoLettoViewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports